var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '100px' })},[_c('h1',[_vm._v("Modals")]),_c('Simple'),_c('Tall'),_c('WithFooter'),_c('WithFooterAndHeader'),_c('WithValidation'),_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }